import Vue from "vue";
import Vuex from "vuex";
import * as apiSettings from "../settings";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    orders: {},
    laundryOrdersToReceive: {},
    laundryOrdersToConfirm: {},
    laundryOrdersObserved: {},
    translations: {
      state: {
        draft: "Sin confirmar",
        order: "Confirmado",
        receive: "En proceso",
        return: "Por recoger",
        cancel: "Cancelado",
        done: "Realizado",
        return_client: "Recogido",
        rejected_reception: "Rechazado",
        claim: "Reclamo"
      }
    },
    user: {
      name: "",
      document_number: "",
      document_type: "",
      company: "",
      cupons: ""
    },
    connection: {
      hostUrl: apiSettings.HOST_URL,
      url: apiSettings.API_URL,
      port: 80,
      db: "odoo_lavanderia",
      client: null,
      username: "",
      password: ""
    },
    couponsSummary: {
      totalCoupons: -1,
      totalCredit: -1,
      currentCredit: -1,
      rejectedOrders: -1
    },
    ordersSummary: {
      approvedOrders: {
        count: -1,
        spentCredit: -1
      },
      rejectedOrders: {
        count: -1
      }
    },
    markers: []
  },

  mutations: {
    clearData: function(state) {
      state.orders = [];
      state.user = {
        name: "",
        document_number: "",
        document_type: "",
        company: "",
        cuppons: "",
        ordersDeepLinkUrl: ""
      };
      state.connection.client = null;
      state.connection.username = "";
      state.connection.password = "";
    },
    setCredentials: function(state, username, password) {
      state.connection.username = username;
      state.connection.password = password;
    },
    setClient: function(state, client) {
      state.connection.client = client;
    },
    reset_orders: function(state) {
      state.orders = [];
    },
    append_order: function(state, order) {
      state.orders.push(order);
    },
    remove: function(state, order) {
      state.orders = state.orders.filter(x => x.id !== order.id);
    },
    pickUp: function(state, order) {
      state.orders = state.orders.filter(x => x.id !== order.id);
    },
    reject: function(state, order) {
      state.orders = state.orders.filter(x => x.id !== order.id);
    },
    refreshUser: function(state, data) {
      let deepLinkTmpl =
        `${state.connection.hostUrl}web#id=${data.referredId}` +
        `&view_type=form&model=laundry.referred`;
      state.user = {
        name: data.username,
        company: "Sociedad Minera Cerro Verde",
        document_number: data.documentNumber,
        document_type: "DNI",
        ordersDeepLinkUrl: deepLinkTmpl
      };
    },
    updateLaundryOrders: function(state, changingOrders) {
      if (changingOrders == undefined) return;
      let approvedOrdersCount = 0;
      let rejectedOrdersCount = 0;
      let spentCredit = 0;
      let orders = {};
      let laundryOrdersToConfirm = {};
      let laundryOrdersToReceive = {};
      let laundryOrdersObserved = {};
      for (var order in changingOrders) {
        let currentOrder = changingOrders[order];
        orders[currentOrder.id] = currentOrder;
        spentCredit += currentOrder.coupons;
        if (currentOrder.status == "cancel") {
          rejectedOrdersCount += 1;
        } else if (currentOrder.status == "draft") {
          laundryOrdersToConfirm[currentOrder.id] = currentOrder;
        } else if (currentOrder.status == "return") {
          laundryOrdersToReceive[currentOrder.id] = currentOrder;
        } else if (currentOrder.status == "rejected_reception") {
          laundryOrdersObserved[currentOrder.id] = currentOrder;
        }
      }
      state.orders = changingOrders;
      state.laundryOrdersToConfirm = laundryOrdersToConfirm;
      state.laundryOrdersToReceive = laundryOrdersToReceive;
      state.laundryOrdersObserved = laundryOrdersObserved;
      state.ordersSummary = {
        approvedOrders: {
          count: approvedOrdersCount,
          spentCredit: spentCredit
        },
        rejectedOrders: {
          count: rejectedOrdersCount
        }
      };
    },
    updateStoreLocations: function(state, newLocations) {
      let newMarkers = [];
      newLocations.forEach(store => {
        let marker = {
          position: {
            lat: Number(store.latitude),
            lng: Number(store.longitude)
          },
          label: store.name,
          address: store.address
        };
        newMarkers.push(marker);
      });
      state.markers = newMarkers;
    },
    updateCouponsSummary: function(state, summary) {
      state.couponsSummary = summary;
    }
  },
  actions: {}
});
